import React from 'react'
import accounting from 'accounting'
import diff from 'deep-diff'
import {t} from '../../helpers/translate'
let config = require('config')

export default class PremiumChangeSuccessComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  getOriginalPremium(){
    return this.props.originalPremium - (this.props.isOverride ? this.props.quote.premium_difference : 0)
  }

  getFinalPremium(){
    if (this.props.isOverride) {
      return this.getOriginalPremium() + this.props.quote.premium_difference;
    }

    return this.props.quote.new_premium;
  }

  getMessage() {
    const currency_format = config.default.currency_format;
    currency_format.symbol = this.props.quote.currency;
    
    if (this.props.quote && (this.props.quote.premium_difference === 0 || this.props.quote.additional_data.premium_difference_net_zero === true )) {
      return t('The premium is not affected.');
    } else {
      return <div>
        <p>{`${t('The premium has changed from ')} 
          ${accounting.formatMoney(this.getOriginalPremium(), currency_format)} 
          ${t(' to ')} 
          ${accounting.formatMoney(this.getFinalPremium(), currency_format)}
          .`}
        </p>
      </div>
    }
  }

  render() {
    return <div>
      <div>
        <p>{t('Your changes have been applied')}.</p>
        <p>{this.getMessage()}</p>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PremiumChangeSuccessComponent.js